import { ILoadPageError, ILoadPageResult } from 'page/layout-build-types.js';
import { useEffect, useState } from 'react';
import { REDUX_AD_CLEAR_CONFIG } from 'redux-state/advertisement/reducer.js';
import { useAppDispatch } from 'redux-state/configure-store.js';
import { REDUX_LAYOUT_RESET } from 'redux-state/layout/reducer.js';
import { REDUX_MODULE_DATAURL_CLEAR } from 'redux-state/modules-dataurl/reducer.js';
import { REDUX_SECONDARY_MODULES_CLEAR } from 'redux-state/modules/reducer.js';
import { FetchError } from 'utilities/fetch/api-gateway.js';
import { buildPageLayout } from '../../page/layout-build.js';
import { PageJSONLoad } from './json-fetch-page.js';
import { JsonResultType } from './json-page-change.js';

/** Build page layout component based on pageJson */
export const JsonUpdateBuildLayoutHook = ({
  pageJson,
  currentLayoutTypeRef,
}: {
  pageJson: JsonResultType;
  currentLayoutTypeRef: React.MutableRefObject<string>;
}) => {
  const appDispatch = useAppDispatch();
  const [pageLayoutResult, setPageLayoutResult] = useState<ILoadPageResult>();

  useEffect(() => {
    const fn = async () => {
      switch (pageJson.type) {
        case PageJSONLoad.Reload:
          /** Page Path is the same, or same as page without overlay
           * So pass same page layout result back so it can update the page state e.g. turn off loading state*/
          setPageLayoutResult((c) => {
            if (c) {
              return { ...c };
            }
            return undefined;
          });
          break;
        case PageJSONLoad.Success: {
          const pageLayoutResult = await buildPageLayout({
            pagePayload: pageJson,
            appDispatch,
          });
          setPageLayoutResult(pageLayoutResult);
          break;
        }
        case PageJSONLoad.Fail: {
          const errType = pageJson.error.type;
          if (errType === FetchError.NETWORK_ERROR || errType === FetchError.SERVER_RESPONSE_ERROR) {
            // // Here we have two kinds of error, page load error and network error
            appDispatch(REDUX_LAYOUT_RESET());
            appDispatch(REDUX_SECONDARY_MODULES_CLEAR());
            appDispatch(REDUX_MODULE_DATAURL_CLEAR());
            appDispatch(REDUX_AD_CLEAR_CONFIG());
            // // Network Error
            setPageLayoutResult({
              layoutLoadSuccess: false,
              error: pageJson.error,
            });
          } else {
            const error: ILoadPageError = {
              type: FetchError.COMPONENT_NOT_FOUND,
              name: FetchError.COMPONENT_NOT_FOUND,
              message: `Unable to load layout ${currentLayoutTypeRef.current}`,
              code: 1,
            };
            setPageLayoutResult({
              layoutLoadSuccess: false,
              error,
            });
          }
          break;
        }
        default:
          // if is loading do nothing
          break;
      }
    };
    fn();
  }, [pageJson, appDispatch, currentLayoutTypeRef]);
  return pageLayoutResult;
};
